module.exports = __webpack_public_path__ + "img/fish3.4ff107a9.png";